<template>
  <div>
    <form-wizard :title="'kk'" >
      <!--      <tab-content :before-change="()=>validateStep('step-1')">-->
      <!--        <step-1 ref="step-1" @on-validate="mergePartialModels"/>-->
      <!--      </tab-content>-->
      <tab-content :before-change="()=>validateStep('step-2')">
        <step-2 :branches="branches" v-if="branches" ref="step-2" @on-validate="mergePartialModels"/>
      </tab-content>
      <tab-content :before-change="()=>validateStep('step-3')">
        <step-3 ref="step-3" @on-validate="mergePartialModels"/>
      </tab-content>
      <tab-content :before-change="()=>validateStep('step-4')">
        <step-4 :services="services" v-if="services" ref="step-4" @on-validate="mergePartialModels"/>
      </tab-content>
      <tab-content :before-change="()=>validateStep('step-5')">
        <step-5 ref="step-5" @on-validate="mergePartialModels"
                :activeDates="activeDates"
                v-if="activeDates"/>
      </tab-content>
      <tab-content :before-change="()=>validateStep('step-6')">
        <step-6 :times="times" :form="form" ref="step-6" @on-validate="mergePartialModels"/>
      </tab-content>


      <template class="mt-5">
        <button slot="prev"  class="btn prev NotoSansGeorgian-Bold"><img src="../assets/img/left-arrow.svg"
                                                                        class="mr-2"/>უკან
        </button>
        <button slot="next"  class="btn btn-success NotoSansGeorgian-Bold"
        >შემდეგი
        </button>
        <button  slot="finish"
                class="btn btn-success NotoSansGeorgian-Bold"
                @click="makeTicket">
          ჯავშანი
        </button>
      </template>
    </form-wizard>

<!--    <ticket v-if="isTicket"-->
<!--            class="pl-md-5 pr-md-5 pl-4 pr-4"/>-->
  </div>
</template>

<script>
//local registration
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
//component code
//import step_1 from './steps/step-1'
import step_2 from './steps/step-2'
import step_3 from './steps/step-3'
import step_4 from './steps/step-4'
import step_5 from './steps/step-5'
import step_6 from './steps/step-6'

export default {
  name: "Home",
  components: {
    FormWizard,
    TabContent,
    // 'step-1': step_1,
    'step-2': step_2,
    'step-3': step_3,
    'step-4': step_4,
    'step-5': step_5,
    'step-6': step_6
  },
  data() {
    return {
      form: {},
      ticket: {},
      activeDates: null,
      branches: null,
      services: null,
      times: {},
      customer: {},
      
    }
  },
  mounted() {
    let element = document.getElementsByClassName("wizard-card-footer");
    element[0].classList.remove("clearfix");

    this.$http.get("/booking/GetBranches")
        .then((r) => {
          //console.log(r.data)
          this.branches = r.data
        })
        .catch((e) => {
          console.error(e)
        })
  },
  watch: {
    'form.office': function (val) {
      this.$http.get("/booking/GetBranchService/" + val)
          .then((r) => {
            this.services = r.data;
            // console.log(r)
          })
          .catch((e) => {
            console.error(e)
          })
    },
    'form.service': function (val) {
      this.$http.get(`/booking/GetBranchServiceDates/${this.form.office}/${val}`)
          .then((r) => {
            this.activeDates = r.data
          })
          .catch((e) => {
            console.error(e)
          })
    },
    'form.date': function (date) {
      this.$http.get(`/booking/GetBranchServiceTimes/${this.form.office}/${this.form.service}/${date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()}`)
          .then((r) => {
            //console.log(r)
            this.times = r.data
          })
          .catch((e) => {
            console.error(e)
          })

    },
    'form.phone': function () {
      this.$http.get(`/booking/CreateCustomer/${this.form.fullName}/${this.form.phone}`)
          .then((r) => {
            //console.log(r)
            this.customer = r.data
          })
          .catch((e) => {
            console.error(e)
          })
    },
  },
  methods: {
    validateStep(name) {
      let refToValidate = this.$refs[name];
      return refToValidate.validate();
    },
    getBranchServices(publicId) {
      this.$http.get("/booking/GetBranchService/" + publicId)
          .then((r) => {
            this.branches = r.data;
            //console.log(r)
          })
          .catch((e) => {
            console.error(e)
          })
    },
    mergePartialModels(model, isValid) {
      if (isValid) {
        // merging each step model into the final model
        this.form = Object.assign({}, this.form, model);
      }
    },
    makeTicket() {
      if (this.$refs['step-6'].validate()){
        this.$http.post(`/booking/Reservation`, {
          PublicId:this.form.office,
          Date:this.form.date,
          Time:this.form.time,
          Title:"",
          Notes:"",
          Customers:this.customer,
          Services:this.form.selectedService,
          Phone:this.form.phone,
          Name:this.form. fullName,
          PersonalId:this.form.idNumber,
        }).then((r) => {
          //console.log(r.data)
          this.$router.push({ name: 'Ticket', params: { tId: r.data.publicId } })          
        }).catch((e) => {
          console.error(e)
        })

      }        
    }
  }

}
</script>

<style scoped>


.btn {
  font-size: 14px !important;
}

.prev {
  color: #00A987 !important;
  padding-left: 0 !important;
}

.disabled-form {
  position: relative;  
}

.disabled-form:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: #ffffff;
  opacity: .6;
  top: 0;
  z-index: 9999;
}

</style>